import { render, staticRenderFns } from "./tmPhonePassLink.vue?vue&type=template&id=3fd0d0b8&"
import script from "./tmPhonePassLink.vue?vue&type=script&lang=js&"
export * from "./tmPhonePassLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports